// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let Intercom = require("../../reason/common/Intercom.bs.js");
let DateFns = require("date-fns");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let FeaturesV3 = require("../../reason/featureFlipper/FeaturesV3.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_object = require("@rescript/runtime/lib/js/Primitive_object.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let BillingSettingsPageSubscription_accountV5_graphql = require("../../__generated__/BillingSettingsPageSubscription_accountV5_graphql.bs.js");

let convertFragment = BillingSettingsPageSubscription_accountV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BillingSettingsPageSubscription_accountV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BillingSettingsPageSubscription_accountV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BillingSettingsPageSubscription_accountV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BillingSettingsPageSubscription_accountV5_graphql.node, convertFragment, fRef);
}

let AccountFragment_accountStatusV5_decode = BillingSettingsPageSubscription_accountV5_graphql.Utils.accountStatusV5_decode;

let AccountFragment_accountStatusV5_fromString = BillingSettingsPageSubscription_accountV5_graphql.Utils.accountStatusV5_fromString;

let AccountFragment_planHandleV5_decode = BillingSettingsPageSubscription_accountV5_graphql.Utils.planHandleV5_decode;

let AccountFragment_planHandleV5_fromString = BillingSettingsPageSubscription_accountV5_graphql.Utils.planHandleV5_fromString;

let AccountFragment_planInterval_decode = BillingSettingsPageSubscription_accountV5_graphql.Utils.planInterval_decode;

let AccountFragment_planInterval_fromString = BillingSettingsPageSubscription_accountV5_graphql.Utils.planInterval_fromString;

let AccountFragment = {
  accountStatusV5_decode: AccountFragment_accountStatusV5_decode,
  accountStatusV5_fromString: AccountFragment_accountStatusV5_fromString,
  planHandleV5_decode: AccountFragment_planHandleV5_decode,
  planHandleV5_fromString: AccountFragment_planHandleV5_fromString,
  planInterval_decode: AccountFragment_planInterval_decode,
  planInterval_fromString: AccountFragment_planInterval_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BillingSettingsPageSubscription$UpgradeToProButton(props) {
  let plan = UserSession.usePlan();
  let isOnTrial = UserSession.Plan.isTrial(plan);
  return JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
    href: "/subscribe",
    size: "small",
    children: isOnTrial ? "Subscribe to PRO Membership" : "Upgrade to PRO Membership"
  });
}

let UpgradeToProButton = {
  make: BillingSettingsPageSubscription$UpgradeToProButton
};

function BillingSettingsPageSubscription(props) {
  let cancelProMembershipFlag = FeaturesV3.useFeatureFlipper("CancelProMembership");
  let cancelProMembershipEnabled = Primitive_object.equal(cancelProMembershipFlag, "on");
  let match = RescriptRelay_Fragment.useFragment(BillingSettingsPageSubscription_accountV5_graphql.node, convertFragment, props.account);
  let subscription = match.sub;
  let match$1 = Intercom.useIntercom();
  let show = match$1.show;
  let match$2 = subscription.plan.interval;
  let intervalPeriod;
  if (match$2 === "INDEFINITE" || match$2 === "YEAR" || match$2 === "MONTH" || match$2 === "QUARTER") {
    switch (match$2) {
      case "INDEFINITE" :
        intervalPeriod = "Indefinite";
        break;
      case "MONTH" :
        intervalPeriod = "monthly";
        break;
      case "QUARTER" :
        intervalPeriod = "quarterly";
        break;
      case "YEAR" :
        intervalPeriod = "annually";
        break;
    }
  } else {
    intervalPeriod = "Indefinite";
  }
  let formattedDate = Stdlib_Option.getOr(Stdlib_Option.map(Stdlib_Option.map(subscription.currentPeriodEnd, x => UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(x))), __x => DateFns.format(__x, "MMMM dd, yyyy")), "[couldn't retrieve date]");
  let cancelAtPeriodEnd = Stdlib_Option.isSome(subscription.cancelAt);
  if (match.accountStatus === "TERMINATED") {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx("div", {
          className: "mt-4"
        }),
        "Your Pro TAN membership has expired.",
        JsxRuntime.jsx("div", {
          className: "mt-4"
        }),
        JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          href: "/subscribe",
          size: "small",
          children: "Reactivate Your Account"
        })
      ]
    });
  }
  let match$3 = subscription.plan.handle;
  if (match$3 !== "COMPLIMENTARY" && match$3 !== "PRO_YEARLY" && match$3 !== "FREE" && match$3 !== "PRO_TRIAL" && match$3 !== "PRO_FREE" && match$3 !== "PRO_QUARTERLY" && match$3 !== "PRO_MONTHLY") {
    return null;
  }
  switch (match$3) {
    case "COMPLIMENTARY" :
      return JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx("div", {
            className: "mt-4"
          }),
          `You have a complimentary Pro TAN membership`
        ]
      });
    case "FREE" :
      return JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx("div", {
            className: "mt-4"
          }),
          `You are currently on the Free membership`,
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(BillingSettingsPageSubscription$UpgradeToProButton, {}),
            className: "mt-4"
          })
        ]
      });
    case "PRO_FREE" :
      return JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx("div", {
            className: "mt-4"
          }),
          `You currently have a free Pro TAN membership`
        ]
      });
    case "PRO_TRIAL" :
      return JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx("div", {
            className: "mt-4"
          }),
          `Your Pro Trial membership expires on ` + formattedDate,
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(BillingSettingsPageSubscription$UpgradeToProButton, {}),
            className: "mt-4"
          })
        ]
      });
    default:
      if (cancelAtPeriodEnd) {
        return JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
              className: "mt-4"
            }),
            `Your Pro TAN membership expires on ` + formattedDate,
            JsxRuntime.jsxs("div", {
              children: [
                "If you want to reactivate your subscription, please ",
                JsxRuntime.jsx("a", {
                  children: "contact us",
                  className: "text-blue-600 underline",
                  href: "",
                  onClick: e => {
                    e.preventDefault();
                    show();
                  }
                }),
                "."
              ],
              className: "mt-4 flex flex-row"
            })
          ]
        });
      } else {
        return JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
              className: "mt-4"
            }),
            `Your Pro TAN membership is billed ` + intervalPeriod + `. It will be renewed on ` + formattedDate,
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                  href: "/subscribe",
                  size: "small",
                  children: "Change PRO Plan"
                }),
                cancelProMembershipEnabled ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                      href: "/cancel-membership",
                      size: "small",
                      children: "Cancel PRO Membership"
                    }),
                    className: "ml-2"
                  }) : null
              ],
              className: "mt-4 flex flex-row"
            }),
            cancelProMembershipEnabled ? null : JsxRuntime.jsx("div", {
                children: "Please contact support if you wish to cancel your PRO TAN membership",
                className: "mt-4"
              })
          ]
        });
      }
  }
}

let make = BillingSettingsPageSubscription;

exports.AccountFragment = AccountFragment;
exports.UpgradeToProButton = UpgradeToProButton;
exports.make = make;
/* Scalars Not a pure module */
